export default __webpack_public_path__ + "1b43a10.png";